export default __webpack_public_path__ + "static/media/Google-Cloud.837d0e2b.png";